module.exports = __webpack_public_path__ + "img/hr-steam-engine-H-shadow.a9b6a2f7.png";